import { ChevronDownIcon, CirclePlusIcon, SearchIcon } from '@/icons';
import { Button, Flex, Input, Select } from 'antd';
import { useGetAllOfficesQuery } from '@/app/features/control-panel/organization/organization.api';
import {
  DISCLOSER_KEYS,
  FILTER_KEYS,
} from '@/constants/keys.constants';
import { useAppDiscloser, useAppFilters } from '@/hooks';
import type { PolicySegmentType } from '../Policies';

const OvertimeFilters = () => {
  const { filters, handleFilter } = useAppFilters(
    FILTER_KEYS.POLICIES_OVERTIME,
  );
  const [_config, handleOpen] = useAppDiscloser(
    DISCLOSER_KEYS.POLICIES_OVERTIME,
  );
  const { data: officesData } = useGetAllOfficesQuery({
    params: { status: 'ACTIVE' },
  });
  return (
    <div className="flex flex-col items-end gap-4">
      <Flex gap={16} align="center" className="flex-wrap! md:flex-nowrap">
        <Select
          allowClear
          size="large"
          style={{ width: 170 }}
          placement="bottomRight"
          placeholder="Office Name"
          suffixIcon={<ChevronDownIcon size={24} className="text-white" />}
          value={filters?.branch}
          onChange={(value) => handleFilter('office_id', value)}
          options={officesData?.data?.data?.map((office) => ({
            value: office.id,
            label: `${office.name}`,
          }))}
        />
        {/* <Select
          allowClear
          size="large"
          style={{ width: 130 }}
          placement="bottomRight"
          placeholder="Policy Type"
          styles={{ popup: { root: { width: 200 } } }}
          suffixIcon={<ChevronDownIcon size={24} className="text-white" />}
          value={filters?.policy_type}
          onChange={(value) => handleFilter('policy_type', value)}
          options={[
            { value: 'standard', label: 'Standard' },
            { value: 'premium', label: 'Premium' },
            { value: 'custom', label: 'Custom' },
          ]}
        /> */}
        <Select
          allowClear
          size="large"
          style={{ width: 130 }}
          placement="bottomRight"
          placeholder="Status"
          // styles={{ popup: { root: { width: 200 } } }}
          suffixIcon={<ChevronDownIcon size={24} className="text-white" />}
          value={filters?.status}
          onChange={(value) => handleFilter('status', value)}
          options={[
            { value: 'active', label: 'Active' },
            { value: 'inactive', label: 'Inactive' },
          ]}
        />
      </Flex>
      <Button
        size="large"
        onClick={() => handleOpen({ type: 'ADD' })}
        className="btn-primary !text-theme-gray-650 !font-bold hover:!text-theme-gray-650 !rounded-md"
      >
        <CirclePlusIcon size={20} />
        Create New Policy
      </Button>
    </div>
  );
};

const LeaveFilters = () => {
  const { filters, handleFilter } = useAppFilters(FILTER_KEYS.POLICIES_LEAVE);
  const [_config, handleOpen] = useAppDiscloser(DISCLOSER_KEYS.POLICIES_LEAVE);
  const { data: officesData } = useGetAllOfficesQuery({
    params: { status: 'ACTIVE' },
  });
  return (
    <div className="flex flex-col items-end gap-4">
      <Flex gap={16} align="center" wrap={true}>
        <Select
          allowClear
          size="large"
          style={{ width: 170 }}
          placement="bottomRight"
          placeholder="Office Name"
          suffixIcon={<ChevronDownIcon size={24} className="text-white" />}
          value={filters?.branch}
          onChange={(value) => handleFilter('office_id', value)}
          options={officesData?.data?.data?.map((office) => ({
            value: office.id,
            label: `${office.name}`,
          }))}
        />
        {/* <Select
          allowClear
          size="large"
          style={{ width: 130 }}
          placement="bottomRight"
          placeholder="Policy Type"
          styles={{ popup: { root: { width: 200 } } }}
          suffixIcon={<ChevronDownIcon size={24} className="text-white" />}
          value={filters?.policy_type}
          onChange={(value) => handleFilter('policy_type', value)}
          options={[
            { value: 'annual', label: 'Annual Leave' },
            { value: 'sick', label: 'Sick Leave' },
            { value: 'maternity', label: 'Maternity Leave' },
            { value: 'paternity', label: 'Paternity Leave' },
          ]}
        /> */}
        <Select
          allowClear
          size="large"
          style={{ width: 130 }}
          placement="bottomRight"
          placeholder="Status"
          // styles={{ popup: { root: { width: 200 } } }}
          suffixIcon={<ChevronDownIcon size={24} className="text-white" />}
          value={filters?.status}
          onChange={(value) => handleFilter('status', value)}
          options={[
            { value: 'active', label: 'Active' },
            { value: 'inactive', label: 'Inactive' },
          ]}
        />
      </Flex>
      <Button
        size="large"
        onClick={() => handleOpen({ type: 'ADD' })}
        className="btn-primary !text-theme-gray-650 !font-bold hover:!text-theme-gray-650 !rounded-md"
      >
        <CirclePlusIcon size={20} />
        Create New Policy
      </Button>
    </div>
  );
};

const ShiftFilters = () => {
  const { filters, handleFilter } = useAppFilters(FILTER_KEYS.POLICIES_SHIFT);
  const [_config, handleOpen] = useAppDiscloser(DISCLOSER_KEYS.POLICIES_SHIFT);
  const { data: officesData } = useGetAllOfficesQuery({
    params: { status: 'ACTIVE' },
  });
  return (
    <div className="flex flex-col items-end gap-4">
      <Flex gap={16} align="center" wrap={true}>
        <Select
          allowClear
          size="large"
          style={{ width: 130 }}
          placement="bottomRight"
          placeholder="Branch"
          styles={{ popup: { root: { width: 200 } } }}
          suffixIcon={<ChevronDownIcon size={24} className="text-white" />}
          value={filters?.branch}
          onChange={(value) => handleFilter('branch', value)}
          options={officesData?.data?.data?.map((office) => ({
            value: office.id,
            label: `${office.name} (${
              office.type === 'HEAD' ? 'Head Office' : 'Branch Office'
            })`,
          }))}
        />
        <Select
          allowClear
          size="large"
          style={{ width: 130 }}
          placement="bottomRight"
          placeholder="Policy Type"
          styles={{ popup: { root: { width: 200 } } }}
          suffixIcon={<ChevronDownIcon size={24} className="text-white" />}
          value={filters?.policy_type}
          onChange={(value) => handleFilter('policy_type', value)}
          options={[
            { value: 'morning', label: 'Morning Shift' },
            { value: 'evening', label: 'Evening Shift' },
            { value: 'night', label: 'Night Shift' },
            { value: 'rotating', label: 'Rotating Shift' },
          ]}
        />
        <Select
          allowClear
          size="large"
          style={{ width: 130 }}
          placement="bottomRight"
          placeholder="Status"
          // styles={{ popup: { root: { width: 200 } } }}
          suffixIcon={<ChevronDownIcon size={24} className="text-white" />}
          value={filters?.status}
          onChange={(value) => handleFilter('status', value)}
          options={[
            { value: 'active', label: 'Active' },
            { value: 'inactive', label: 'Inactive' },
            { value: 'draft', label: 'Draft' },
          ]}
        />
      </Flex>
      <Button
        size="large"
        onClick={() => handleOpen({ type: 'ADD' })}
        className="btn-primary !text-theme-gray-650 !font-bold hover:!text-theme-gray-650 !rounded-md"
      >
        <CirclePlusIcon size={20} />
        Create New Policy
      </Button>
    </div>
  );
};

const RecruitmentFilters = () => {
  const { filters, handleFilter } = useAppFilters(
    FILTER_KEYS.POLICIES_RECRUITMENT,
  );
  const [_config, handleOpen] = useAppDiscloser(
    DISCLOSER_KEYS.POLICIES_RECRUITMENT,
  );
  const { data: officesData } = useGetAllOfficesQuery({
    params: { status: 'ACTIVE' },
  });
  return (
    <div className="flex flex-col items-end gap-4">
      <Flex gap={16} align="center" wrap={true}>
        <Select
          allowClear
          size="large"
          style={{ width: 130 }}
          placement="bottomRight"
          placeholder="Branch"
          styles={{ popup: { root: { width: 200 } } }}
          suffixIcon={<ChevronDownIcon size={24} className="text-white" />}
          value={filters?.branch}
          onChange={(value) => handleFilter('branch', value)}
          options={officesData?.data?.data?.map((office) => ({
            value: office.id,
            label: `${office.name} (${
              office.type === 'HEAD' ? 'Head Office' : 'Branch Office'
            })`,
          }))}
        />
        <Select
          allowClear
          size="large"
          style={{ width: 130 }}
          placement="bottomRight"
          placeholder="Policy Type"
          styles={{ popup: { root: { width: 200 } } }}
          suffixIcon={<ChevronDownIcon size={24} className="text-white" />}
          value={filters?.policy_type}
          onChange={(value) => handleFilter('policy_type', value)}
          options={[
            { value: 'internal', label: 'Internal Hiring' },
            { value: 'external', label: 'External Hiring' },
            { value: 'referral', label: 'Employee Referral' },
            { value: 'contract', label: 'Contract Hiring' },
          ]}
        />
        <Select
          allowClear
          size="large"
          style={{ width: 130 }}
          placement="bottomRight"
          placeholder="Status"
          styles={{ popup: { root: { width: 200 } } }}
          suffixIcon={<ChevronDownIcon size={24} className="text-white" />}
          value={filters?.status}
          onChange={(value) => handleFilter('status', value)}
          options={[
            { value: 'active', label: 'Active' },
            { value: 'inactive', label: 'Inactive' },
            { value: 'draft', label: 'Draft' },
          ]}
        />
      </Flex>
      <Button
        size="large"
        onClick={() => handleOpen({ type: 'ADD' })}
        className="btn-primary !text-theme-gray-650 !font-bold hover:!text-theme-gray-650 !rounded-md"
      >
        <CirclePlusIcon size={20} />
        Create New Policy
      </Button>
    </div>
  );
};

const ExpenseFilters = () => {
  const { filters, handleFilter } = useAppFilters(FILTER_KEYS.POLICIES_EXPENSE);
  const [_config, handleOpen] = useAppDiscloser(
    DISCLOSER_KEYS.POLICIES_EXPENSE,
  );
  const { data: officesData } = useGetAllOfficesQuery({
    params: { status: 'ACTIVE' },
  });
  return (
    <div className="flex flex-col items-end gap-4">
      <Flex gap={16} align="center" wrap={true}>
        <Input
          prefix={<SearchIcon size={20} className="text-white" />}
          placeholder="Search by name"
          size="large"
          style={{ width: 250 }}
          value={filters?.search}
          onChange={(e) => handleFilter('search', e.target.value)}
        />
        <Select
          allowClear
          size="large"
          style={{ width: 130 }}
          placement="bottomRight"
          placeholder="Office"
          styles={{ popup: { root: { width: 200 } } }}
          suffixIcon={<ChevronDownIcon size={24} className="text-white" />}
          value={filters?.office}
          onChange={(value) => handleFilter('office', value)}
          options={officesData?.data?.data?.map((office) => ({
            value: office.id,
            label: `${office.name} (${
              office.type === 'HEAD' ? 'Head Office' : 'Branch Office'
            })`,
          }))}
        />
        <Select
          allowClear
          size="large"
          style={{ width: 130 }}
          placement="bottomRight"
          placeholder="Department"
          styles={{ popup: { root: { width: 200 } } }}
          suffixIcon={<ChevronDownIcon size={24} className="text-white" />}
          value={filters?.department}
          onChange={(value) => handleFilter('department', value)}
          options={[
            { value: 'hr', label: 'Human Resources' },
            { value: 'finance', label: 'Finance' },
            { value: 'it', label: 'Information Technology' },
            { value: 'marketing', label: 'Marketing' },
            { value: 'operations', label: 'Operations' },
          ]}
        />
        <Select
          allowClear
          size="large"
          style={{ width: 130 }}
          placement="bottomRight"
          placeholder="Grade"
          styles={{ popup: { root: { width: 200 } } }}
          suffixIcon={<ChevronDownIcon size={24} className="text-white" />}
          value={filters?.grade}
          onChange={(value) => handleFilter('grade', value)}
          options={[
            { value: 'junior', label: 'Junior' },
            { value: 'senior', label: 'Senior' },
            { value: 'lead', label: 'Lead' },
            { value: 'manager', label: 'Manager' },
            { value: 'director', label: 'Director' },
          ]}
        />
        <Select
          allowClear
          size="large"
          style={{ width: 130 }}
          placement="bottomRight"
          placeholder="Policy Type"
          styles={{ popup: { root: { width: 200 } } }}
          suffixIcon={<ChevronDownIcon size={24} className="text-white" />}
          value={filters?.policy_type}
          onChange={(value) => handleFilter('policy_type', value)}
          options={[
            { value: 'travel', label: 'Travel Expenses' },
            { value: 'medical', label: 'Medical Expenses' },
            { value: 'training', label: 'Training Expenses' },
            { value: 'equipment', label: 'Equipment Expenses' },
          ]}
        />
        <Select
          allowClear
          size="large"
          style={{ width: 130 }}
          placement="bottomRight"
          placeholder="Status"
          styles={{ popup: { root: { width: 200 } } }}
          suffixIcon={<ChevronDownIcon size={24} className="text-white" />}
          value={filters?.status}
          onChange={(value) => handleFilter('status', value)}
          options={[
            { value: 'active', label: 'Active' },
            { value: 'inactive', label: 'Inactive' },
            { value: 'draft', label: 'Draft' },
          ]}
        />
      </Flex>
      <Button
        size="large"
        onClick={() => handleOpen({ type: 'ADD' })}
        className="btn-primary !text-theme-gray-650 !font-bold hover:!text-theme-gray-650 !rounded-md"
      >
        <CirclePlusIcon size={20} />
        Create New Policy
      </Button>
    </div>
  );
};

type Props = { type: PolicySegmentType };
const Filters = ({ type }: Props) => {
  switch (type) {
    case 'overtime':
      return <OvertimeFilters />;
    case 'leave':
      return <LeaveFilters />;
    case 'shift':
      return <ShiftFilters />;
    case 'recruitment':
      return <RecruitmentFilters />;
    case 'expense':
      return <ExpenseFilters />;
    default:
      return null;
  }
};
export default Filters;
